module.exports = __webpack_public_path__ + "img/c-bg-bottom.701dff6c.png";